import PrimaryBox from "./PrimaryBox";

export default PrimaryBox;
export { PrimaryBox };
